import React, {useEffect, useState} from "react";
import {
    IonButton,
    IonContent,
    IonInput, IonItem, IonList,
    IonPage,
    IonSelect,
    IonSelectOption,
    useIonViewDidEnter,
    useIonViewWillLeave
} from "@ionic/react";
import {useTranslation} from "react-i18next";
import {Institution} from "../services/types/apitypes";
import {apiGetInstitutions, apiLinkCardToInstitution} from "../services/api";
import useEnhancedAuth from "../EnhancedAuth";
import {useHistory, useParams} from "react-router";
import AppPageHeader from "../components/AppPageHeader";
import {useToaster} from "../hooks/useToaster";
import {getAppError, getAppSuccess, getUserMessageOrValidationError} from "../utils/messages";
import {uiInputMode} from "../utils/ui";
import AppLoading from "../components/AppLoading";
import InstitutionBox from "../components/InstitutionBox";

export const InstitutionsRegisterPageLink: React.FC = () => {

    const {t} = useTranslation('global');
    const { cardid } = useParams<{ cardid: string }>();

    const router = useHistory()

    const [present] = useToaster();


    const [isPageActive, setIsPageActive] = useState(false);
    useIonViewDidEnter(() => {
        setIsPageActive(true);
    });
    useIonViewWillLeave(() => {
        setIsPageActive(false);
    });

    const [institutions, setInstitutions] = React.useState<Institution[]>([]);
    const auth = useEnhancedAuth();

    const [registrationCode, setRegistrationCode] = React.useState<string | undefined>(undefined);
    const [institution, setInstitution] = React.useState<Institution | undefined>(undefined);
    const [institutionFilter, setInstitutionFilter] = React.useState<string>("");
    const [error, setError] = React.useState<string | undefined>(undefined);
    const [submitting, setSubmitting] = React.useState<boolean>(false);
    const [loading, setLoading] = React.useState<boolean>(true);

    useEffect(() => {
        const getInstitutions = async () => {
            try {
                const institutions = await apiGetInstitutions(auth);
                setInstitutions(institutions.data);
            } catch (e: unknown) {
                const apiError = getUserMessageOrValidationError(error);
                if (typeof apiError === 'string') {
                    present(getAppError(apiError));
                }
            } finally {
                setLoading(false);
            }
        }

        getInstitutions();
    }, []);

    function goBack() {
        if (!institution) {
            router.push('/card/' + cardid + '/institution');
        } else {
            setInstitution(undefined);
        }
    }

    async function submit() {
        if (registrationCode && institution && cardid && registrationCode) {
            setSubmitting(true);
            try {
                const result = await apiLinkCardToInstitution(auth, institution.id, cardid, registrationCode);
                setError(undefined);
                if (result) {
                    present(getAppSuccess(t('institutions.success')));
                    router.push('/card/' + cardid + '/institution');
                }
            } catch (error) {
                const apiError = getUserMessageOrValidationError(error);
                if (typeof apiError === 'string') {
                    present(getAppError(apiError));
                    setError(apiError);
                } else {
                    present(getAppError(t('institutions.error')));
                }
            } finally {
                setSubmitting(false);
            }
        }
    }

    return <IonPage id="farecardvalue-page">
        <AppPageHeader
            isPageActive={isPageActive}
            back={goBack}
            title={t('institutions.link')}
        ></AppPageHeader>

        <AppLoading hidden={!loading && !submitting} />
        <IonContent fullscreen className="ion-padding default-content">
            {!institution && <>
                <p className="pt-2 pb-3 instructions ion-text-center">
                    {t('institutions.info')}
                </p>
                <IonInput placeholder={t('institutions.search_name') ?? ''} value={institutionFilter} onIonInput={(e) => setInstitutionFilter(""+e.target.value)}></IonInput>
                <IonList inset={false}>
                    {institutions.filter(i => i.name.toUpperCase().includes(institutionFilter.toUpperCase())).map(institution => (<IonItem key={institution.id} button onClick={() => setInstitution(institution)}><span style={{"color": "#0068BD"}}>{institution.name}</span></IonItem>))}
                </IonList>
            </>}
            {institution && <>
                <InstitutionBox institution={institution}></InstitutionBox>
                <div style={{
                    "display": "flex",
                    "flexFlow": "column",
                    "gap": "0.375rem",
                    "marginBottom": "1.5rem",
                }}>
                    <label style={{"fontWeight": "bold", "fontSize": "0.938rem"}}>{t('institutions.institution_code') }</label>
                    <IonInput
                        disabled={submitting}
                        placeholder={t('institutions.institution_code') ?? ''}
                        value={registrationCode}
                        fill={"outline"}
                        mode={uiInputMode()}
                        className={`ion-touched ${error ? 'ion-invalid' : ''}`}
                        onIonInput={e => setRegistrationCode(""+e.target.value)} ></IonInput>
                    {error ? <label style={{"fontSize": "0.75rem", "color": "#C5000F"}}>{error}</label> : <label style={{"fontSize": "0.75rem", "color": "#808080"}}>{t('institutions.institution_code_hint') }</label>}
                </div>
                <div className="ion-text-center">
                    <IonButton
                        disabled={submitting || !registrationCode || !institution}
                        style={{"margin": "0 auto"}} className="btn-default btn-wide-100" onClick={() => submit()}>
                        {t('institutions.link_institution')}
                    </IonButton>
                </div>
            </>}
        </IonContent>


    </IonPage>
}